import { TFunction } from 'i18next';
import dayjs from 'shared/helpers/dayjs';

export default function formatNoteDateTime(
  created: string,
  t: TFunction
): string {
  const noteCreated = dayjs(created);
  const now = dayjs();
  let dateLabel: string;
  if (noteCreated.isSame(now, 'day')) {
    dateLabel = t('currentShift.Today');
  } else if (noteCreated.isSame(now.subtract(1, 'day'), 'day')) {
    dateLabel = t('currentShift.Yesterday');
  } else if (noteCreated.isSame(now, 'year')) {
    dateLabel = noteCreated.format('ddd, MMM D');
  } else {
    dateLabel = noteCreated.format('ddd, MMM D, YYYY');
  }
  return t('note.dateAtTime', {
    date: dateLabel,
    time: noteCreated.format('h:mm A'),
  });
}
